module.exports = __webpack_public_path__ + "img/55f.9779552b.png";